import React from 'react'
import { Banner } from './banner'
import { AlertSection } from './alertSection'

export const AlertNotify = () => {
  return (
    <>
    <Banner />
    <AlertSection />
    </>
  )
}
